// A readout swap as a roll, not a crossfade: the old text lifts out of its
// box and the new text rises into the same box. Nothing around it moves.
//
// The elements carry .readout-roll (application.css), which owns the three
// states this walks through: .is-swapping lifts out, .is-arriving is the
// start of the rise with the transition off, and .is-rising plays it.
// `apply` runs between the two, once the old text is gone, and writes the
// new one. Used by the budget card's end column (budget_bar_controller) and
// the dashboard band's headline (flexible_toggle_controller).
export const OUT_MS = 140
export const IN_MS = 300

export function rollSwap(elements, apply, { outMs = OUT_MS, inMs = IN_MS } = {}) {
  let outTimer, inTimer, frame

  elements.forEach((el) => {
    el.classList.remove("is-arriving", "is-rising")
    el.classList.add("is-swapping")
  })

  outTimer = setTimeout(() => {
    apply()

    elements.forEach((el) => {
      el.classList.remove("is-swapping")
      el.classList.add("is-arriving")
    })
    // Commit the start position before the next frame takes it away, or the
    // browser folds both writes into one and nothing rises.
    void elements[0].offsetWidth
    frame = requestAnimationFrame(() => {
      elements.forEach((el) => {
        el.classList.remove("is-arriving")
        el.classList.add("is-rising")
      })
      inTimer = setTimeout(() => {
        elements.forEach((el) => el.classList.remove("is-rising"))
      }, inMs)
    })
  }, outMs)

  return {
    cancel() {
      clearTimeout(outTimer)
      clearTimeout(inTimer)
      cancelAnimationFrame(frame)
    }
  }
}
